// Fake toNumber function that converts a string to a number
// This function is used to convert a string to a number

export const toNumber = (value) => {
  return typeof value === "number" ? value : parseInt(value.replace(/,/g, ""));
};
